import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const isSuperAdmin = () => localStorage.getItem("admin_role") === "admin";
export const getCurrentRole = () => localStorage.getItem("admin_role") || "";
export const getCurrentEmail = () => localStorage.getItem("admin_email") || "";

export const PART_TYPES = [
  { value: "motore", label: "Motore" },
  { value: "cambio", label: "Cambio" },
];

export const STATUS_LABELS = {
  nuovo: "Nuovo",
  contattato: "Contattato",
  confermata: "Confermata",
  spedita: "Spedita",
  consegnata: "Consegnata",
  annullata: "Annullata",
};

export const STATUS_COLORS = {
  nuovo: "bg-blue-50 text-blue-700 border-blue-200",
  contattato: "bg-amber-50 text-amber-700 border-amber-200",
  confermata: "bg-indigo-50 text-indigo-700 border-indigo-200",
  spedita: "bg-purple-50 text-purple-700 border-purple-200",
  consegnata: "bg-emerald-50 text-emerald-700 border-emerald-200",
  annullata: "bg-red-50 text-red-700 border-red-200",
};

export const SHIPMENT_STATUS_LABELS = {
  "": "Non spedito",
  in_preparazione: "In preparazione",
  spedito: "Spedito",
  in_arrivo: "In arrivo",
  in_consegna: "In consegna",
  consegna_riprogrammata: "Consegna riprogrammata",
  cliente_non_trovato: "Cliente non trovato",
  consegnato: "Consegnato",
};

export const SHIPMENT_STATUS_OPTIONS = [
  "in_preparazione", "spedito", "in_arrivo", "in_consegna",
  "consegna_riprogrammata", "cliente_non_trovato", "consegnato",
];

export const SHIPMENT_STATUS_COLORS = {
  in_preparazione: "bg-slate-50 text-slate-700 border-slate-200",
  spedito: "bg-blue-50 text-blue-700 border-blue-200",
  in_arrivo: "bg-indigo-50 text-indigo-700 border-indigo-200",
  in_consegna: "bg-red-50 text-red-700 border-red-200",
  consegna_riprogrammata: "bg-amber-50 text-amber-700 border-amber-200",
  cliente_non_trovato: "bg-red-100 text-red-800 border-red-300",
  consegnato: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export const COURIERS = [
  { value: "GLS", label: "GLS", trackUrl: (n) => `https://www.gls-italy.com/?option=com_gls&view=track_e_trace&numero_spedizione=${n}` },
  { value: "BRT", label: "BRT (Bartolini)", trackUrl: (n) => `https://vas.brt.it/vas/sped_dettaglio_eng.hsm?referer=sped_ricerca_numspe_par.htm&Nspedizione=${n}` },
  { value: "SDA", label: "SDA", trackUrl: (n) => `https://www.sda.it/wps/portal/Servizi_online/dettaglio-spedizione?locale=it&tracing.letteraVettura=${n}` },
  { value: "DHL", label: "DHL", trackUrl: (n) => `https://www.dhl.com/it-it/home/tracking/tracking-express.html?submit=1&tracking-id=${n}` },
  { value: "Poste", label: "Poste Italiane", trackUrl: (n) => `https://www.poste.it/cerca/index.html#/risultati-spedizioni/${n}` },
  { value: "TNT", label: "TNT / FedEx", trackUrl: (n) => `https://www.fedex.com/fedextrack/?trknbr=${n}` },
  { value: "Nexive", label: "Nexive", trackUrl: (n) => `https://www.nexive.it/track-trace/?codice=${n}` },
  { value: "Altro", label: "Altro corriere", trackUrl: () => null },
];

export const getCourierTrackUrl = (courier, tracking) => {
  if (!courier || !tracking) return null;
  const c = COURIERS.find((x) => x.value === courier);
  return c?.trackUrl(tracking) || null;
};

export const WHATSAPP_NUMBER = "393505172668";
export const PHONE_NUMBER = "+39 350 517 2668";

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("it-IT", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
};

export const buildWhatsappLink = (name, partType, engineCode) => {
  const label = partType === "motore" ? "motore" : "cambio";
  const msg = `Ciao Officina Franco! Sono ${name}, ho appena inviato una richiesta dal sito per un ${label} (codice: ${engineCode}). Resto in attesa di vostre informazioni. Grazie!`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
};
